import Link from '@mui/material/Link';

import { formatPhone } from 'reservations/base/helpers/phone';
import { SOY } from 'reservations/brand/constants';

export const getMaxPartySizeText = (
  emailAddress: string,
  phoneNumber: string,
  partySize: string
) => {
  const baseMessage = `For parties of ${parseFloat(partySize)} or more, please`;
  let contactMethod = 'contact us';
  let LinkComponent = null;

  if (!!phoneNumber) {
    LinkComponent = (
      <Link
        data-testid="max-party-size-phone"
        href={`tel:${phoneNumber}`}
        target="_blank"
        rel="noopener"
        underline="none"
        sx={{ color: SOY }}
      >
        {formatPhone(phoneNumber)}
      </Link>
    );
    contactMethod = `call us at `;
  } else if (!!emailAddress) {
    LinkComponent = (
      <Link
        data-testid="max-party-size-email"
        href={`mailto:${emailAddress}`}
        target="_blank"
        rel="noopener"
        underline="none"
        sx={{ color: SOY }}
      >
        {emailAddress}
      </Link>
    );
    contactMethod = `email us at `;
  }

  return {
    message: `${baseMessage} ${contactMethod}`,
    LinkComponent
  };
};
